import { withNaming } from "@bem-react/classname";

export const cn = withNaming({
  n: "common-ui-components-",
  e: "__",
  m: "_",
});
